// extracted by mini-css-extract-plugin
export var pillWrapper = "_qf-0";
export var showOverflow = "_qf-1";